import { Injectable, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { BANNER_CONSTANTS } from '@commoncore/constants/bannerConstants';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { CleverTapEventsService } from '@commoncore/services/clevertap-events-service';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { SettingsService } from '@commoncore/services/settings.service';
import { ActiveRepo } from '@commoncore/services/universal.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ProfileImplementation } from '../implementation/ProfileImplementation';
// import { USER_DETAILS } from '../constants/Constants';
// import { PreviewImplementation } from '@commoncore/implementation/PreviewImplementation';

@Injectable({
  providedIn: 'root'
})
class AuthorizationService{

  userloginController:any;
  universalService:any;
  router:any
  route:any;
  localStorageSvc: LocalStorageSvc;
  rootFolderKey: string;
  profileImpl: any;
  cleverTapEventsService:CleverTapEventsService;
  userLoginImplementation:any;
  shareAccessService:any;
  contextMenuService:any;
  enableTakeout:any;
  searchService: any;
  deviceService:any
  //TODO: service like ping can be integrated here
  constructor(public globalService:GlobalService,public settingsService:SettingsService){
    
    this.userloginController= UserloginController.getInstance(this.globalService);
    this.userloginController.setEnvObjects(this.globalService)
    this.userLoginImplementation = this.userloginController.userLoginImplementation;
    this.universalService = this.globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.route = globalService.getActivatedRoute();
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.profileImpl = ProfileImplementation.getInstance(this.globalService);
    this.cleverTapEventsService  = globalService.getCleverTapEventsvc();
    this.shareAccessService = globalService.getShareAccessServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.enableTakeout = ENV_CONSTANTS["constants"]["enableTakeout"];
    this.searchService = globalService.getSearchServiceRef();
    this.deviceService =  globalService.getDeviceServiceRef();
  }
  
  canActivate(next,state): Promise<boolean> | boolean {
        this.universalService.showMobOptionMenu = false;
        this.universalService.showCreateFolderAndUploadButtons = false;
        this.universalService.showTopMoreOptionsOnMobile = true;
        this.universalService.showPreview = false;
        this.universalService.destinationFolder = {"objectName":"JioAICloud"};
        this.universalService.folderSpecificDrag = false;
        this.universalService.dragDropWithinApp = false;
        this.searchService.openAutoSearch.next(false);
        // var previewImpl = PreviewImplementation.getInstance(this.globalService)
        // if(this.universalService.showPreview){
        //   this.universalService.showPreview = false;
        //   previewImpl.closePreview();
        //   return false;
        // }else if (next.data.page == "about" || next.data.page == "pricing" || next.data.page == "features"){
        //   return true;
        // }
        return this.isValidStaySignIn(state.url,next).then(val=>{
          // $("#jc-app-init-loader-cont").hide();
          return val
        });
        
  }

  async isValidStaySignIn(stateurl,currentRoute){
    AppEvents.emit(EventsList.DOWNTIME_BANNER);
    let userData = this.localStorageSvc.getUserData(true) 
    //if (JSON.parse(this.localStorageSvc.isStaySigned()) && !this.universalService.isPingEnabled) {
    if (userData && userData["isStaySignIn"] && !this.universalService.isPingEnabled) {
      await this.userloginController.getCookie();
      await this.userloginController.refreshData(true,false,true);
     if(this.localStorageSvc.getUserData() == null || 
       this.localStorageSvc.getUserData() ==undefined){
         this.universalService.disableModalBackdrop();
         this.router.navigate(['/']);
       return false
     }else{
        var result = await this.chech2FAValidationStatus(currentRoute);
        return result;
     }
   }else{
     
    if(this.localStorageSvc.getUserData() == null || this.localStorageSvc.getUserData() ==undefined){
        var nativeHeaders = this.localStorageSvc.getNativeHeaders('nativeHeaders');
        if(window.location.href.includes('webview')){
          return true;
        }else if(this.universalService.inAppWebViewOpened){
          return true;
        }else if(nativeHeaders){
          return true
        }
        this.universalService.disableModalBackdrop();
        if(this.universalService.activeRepo == ActiveRepo.ENTERPRISE){
          window.open("/","_self", "noopener, noreferrer");
          return false;
        }else
        this.router.navigate(['/']);
        return false;
    }else{
        await this.userloginController.getCookie();
        var result = await this.chech2FAValidationStatus(currentRoute);
        return result;
    }
    
   } 
  }

  async chech2FAValidationStatus(currentRoute){
    let userData = this.localStorageSvc.getUserData(true) 
    if(userData && userData.jcEntInfo  && window.location.href.includes("/dataexport")){
      window.location.href = "/home";
      return false;
    }else{
      let twoFAEnabled = this.localStorageSvc.getTwoFAEnable(true);
      let status = JSON.parse(localStorage.getItem('passPhraseValidationSuccess'))
      if((twoFAEnabled == 'Y' && status == true)||twoFAEnabled == 'N'||twoFAEnabled == undefined){
          await this.updateUserDetails();
        AppEvents.albumDetails.observers = [];
        return true;
      }else{
        // if(!currentRoute.data.disable2FA){ // do not remove this code, need to find a better approach to fetch the route data when canMatch guard is being used
          this.universalService.show2FApopUp = true
        // }
        if(status == true){
          return true;
        }else{
          return true;
        }
      }
    }
  }

  async fetchUserProfile() {
    
    try {
      let response = await this.userLoginImplementation.getUserDetails();
      this.profileImpl.publicAlbumConsent = response["publicBoardConsent"]
      let invokeAppEvent = localStorage.getItem('invokeAppEvent');
      if(invokeAppEvent!=null && invokeAppEvent == "Y" && response["metaSearchJc"]["isMetaJcEnabled"] == "N"){
        localStorage.removeItem('invokeAppEvent');
        this.userLoginImplementation.updateAppEvent(this.deviceService.browser,this.deviceService.browser_version);
      }

      return Promise.resolve(response)
    }
    catch (err) {
      Promise.reject(err)
    }
  }

  async updateUserDetails(){
    
    let userProfileData = await this.fetchUserProfile();
    if(userProfileData == undefined) {
      return false;
    }
    this.universalService.firstName  = userProfileData.firstName;
    this.universalService.lastNfame = userProfileData.lastName ;
    this.universalService.emailId = userProfileData.emailId;
    setTimeout(() => {
        AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
    }, 2000);
  }
}

export const AuthGuard: CanActivateFn =
    (route, state) => {
      return inject(AuthorizationService).canActivate(route,state);
    }
